export default function parseMoneyToNumber(value) {
  if (value === null || value === undefined || value === '') {
    return 0
  }

  const normalized = String(value)
    .replace(/\s/g, '')
    .replace(/[^\d,.-]/g, '')

  if (!normalized) {
    return 0
  }

  let cleaned = normalized

  if (normalized.includes(',') && normalized.includes('.')) {
    const lastComma = normalized.lastIndexOf(',')
    const lastDot = normalized.lastIndexOf('.')

    cleaned = lastComma > lastDot
      ? normalized.replace(/\./g, '').replace(',', '.')
      : normalized.replace(/,/g, '')
  } else if (normalized.includes(',')) {
    cleaned = normalized.replace(',', '.')
  }

  const parsed = Number(cleaned)

  return Number.isFinite(parsed) ? parsed : 0
}
